export const VOTER_CLASSIFICATIONS = Object.freeze({
  BLACK: 'BLACK',
  WHITE: 'WHITE',
});

export const VOTER_CLASSIFICATION_META = Object.freeze({
  [VOTER_CLASSIFICATIONS.BLACK]: Object.freeze({
    label: 'Verde',
    description: 'Este votante genera un gasto para la campaña.',
    expenseLabel: 'Gasto habilitado',
    dotClass: 'bg-emerald-600',
    badgeClass: 'border-emerald-700 bg-emerald-600 text-white',
  }),
  [VOTER_CLASSIFICATIONS.WHITE]: Object.freeze({
    label: 'Blanco',
    description: 'Este votante no genera gastos para la campaña.',
    expenseLabel: 'Sin gasto',
    dotClass: 'border border-slate-400 bg-white',
    badgeClass: 'border-slate-300 bg-white text-slate-700',
  }),
});

export const normalizeVoterClassification = (value) =>
  ['BLACK', 'NEGRO', 'VERDE', 'A'].includes(String(value || '').toUpperCase())
    ? VOTER_CLASSIFICATIONS.BLACK
    : VOTER_CLASSIFICATIONS.WHITE;
